import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ToastContainer } from "react-toastify";
import { ChakraProvider } from "@chakra-ui/react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  logWebVital,
  startPerformanceMonitoring,
} from "./utils/performanceMonitoring";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      gcTime: 30 * 60 * 1000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});

startPerformanceMonitoring();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(

  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
    <ChakraProvider>
    <App />
    <ToastContainer />
    </ChakraProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

reportWebVitals(logWebVital);
